import { Box } from "app/components/common";
import FeelingQuestionChallengeIcon from "app/components/Icons/Images/FeelingQuestionChallenge";
import theme from "app/Theme/Theme";
import normalize from "app/utils/normalize";
import React from "react";
import { Dimensions } from "react-native";
import { StarAnimated } from "./StarAnimated";

interface Props {
  previousStarSelected: number;
  rating: number;
}

const dimensions = Dimensions.get("window");
const STAR_BOX_SIZE =
  dimensions.height >= theme.breakpoints.smallWeb.height &&
  dimensions.width >= theme.breakpoints.smallWeb.width &&
  dimensions.height < theme.breakpoints.web.height
    ? 180
    : normalize(190);

const AllStarsAnimated = ({ previousStarSelected, rating }: Props) => {
  return (
    <Box
      flex={1}
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      <Box flexDirection="row" zIndex={2}>
        <StarAnimated
          previousStarSelected={previousStarSelected}
          starNumber={2}
          rotateY={-47}
          right={normalize(60)}
          top={normalize(20)}
          isToggle={rating >= 2}
        />
        <StarAnimated
          previousStarSelected={previousStarSelected}
          rotateY={-15}
          starNumber={3}
          right={normalize(15)}
          top={normalize(-15)}
          isToggle={rating >= 3}
        />
        <StarAnimated
          previousStarSelected={previousStarSelected}
          starNumber={4}
          rotateY={15}
          left={normalize(15)}
          top={normalize(-15)}
          isToggle={rating >= 4}
        />
        <StarAnimated
          previousStarSelected={previousStarSelected}
          starNumber={5}
          rotateY={47}
          left={normalize(60)}
          top={normalize(20)}
          isToggle={rating >= 5}
        />
      </Box>
      {rating > 0 ? (
        <Box
          height={STAR_BOX_SIZE}
          width={STAR_BOX_SIZE}
          borderRadius={STAR_BOX_SIZE / 2}
          backgroundColor="neutral.50"
          justifyContent="center"
          alignItems="center"
          marginBottom="m"
        >
          <StarAnimated
            previousStarSelected={previousStarSelected}
            starNumber={1}
            isToggle={rating >= 1}
            imageStyle={{
              height: normalize(130),
              width: normalize(130),
              zIndex: 1,
              marginTop: -15,
            }}
          />
        </Box>
      ) : (
        <Box marginBottom="m" justifyContent="center" alignItems="center">
          <FeelingQuestionChallengeIcon
            width={STAR_BOX_SIZE}
            height={STAR_BOX_SIZE}
          />
        </Box>
      )}
    </Box>
  );
};

export default AllStarsAnimated;
